import React from "react";
import { useTheme } from "../contexts/ThemeContext";

export default function PageHeader({ title, subtitle, children }) {
  const { darkMode } = useTheme();
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-3">
      <div className="min-w-0">
        <h1 className={`text-lg sm:text-2xl font-bold truncate ${darkMode ? "text-white" : "text-gray-900"}`}>
          {title}
        </h1>
        {subtitle && (
          <p className={`hidden sm:block mt-1 text-sm ${darkMode ? "text-gray-400" : "text-gray-500"}`}>
            {subtitle}
          </p>
        )}
      </div>
      {children && <div className="flex items-center flex-wrap gap-1.5 sm:gap-3 shrink-0">{children}</div>}
    </div>
  );
}
